import "./styles.scss";
import CardDetailDescription from "../../organims/CardDetail/cardDetailDescription";

export default function CardDetail() {
  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-100 d-flex justify-content-md-start justify-content-lg-start flex-column">
        <div className="w-100 d-flex flex-column align-items-center">
          {
            // TODO: Add paramethers
          }
          <CardDetailDescription />
        </div>
      </div>
    </div>
  );
}
